<template>
<div class="daoh2">
<!--    <el-menu class="el-menu-vertical-demo" :collapse="isCollapse" :default-active="$route.path">-->
<!--        <router-link v-for="item1 in item" :key="item1.path" :to="item1.path" >-->
<!--            <el-menu-item :index="item1.path">-->
<!--                <span slot="title">{{item1.label}}</span>-->
<!--            </el-menu-item>-->
<!--        </router-link>-->
<!--    </el-menu>-->
    <div class="ti">
      <router-view></router-view>
    </div>
</div>
</template>
<script>
export default {
  name: 'ConversationIndex',
  data () {
    return {
      isCollapse: false,
      item:[],
      activeIndex: '1010301',
      items_list1:[
          {
            id:'1010301',
            label: '会话管理',
            icon: 'mdi-home-outline ',
            path:'/Conversation/Chat',
            pid:101030,
          },
          {
            id:'1010302',
            label: '关键字管理',
            icon: 'mdi-home-outline ',
            path:'/Conversation/Keyword',
            pid:101030,
          },
          {
            id:'1010303',
            label: '群管理',
            icon: 'mdi-home-outline ',
            path:'/Conversation/GroupChat',
            pid:101030,
          },
          {
            id:'1010304',
            label: '社群总览',
            icon: 'mdi-home-outline ',
            path:'/Conversation/Overview',
            pid:101030,
          },
          {
            id:'1010305',
            label: '项目活跃分析',
            icon: 'mdi-home-outline ',
            path:'/Conversation/ProjectActive',
            pid:101030,
          },
          {
            id:'1010306',
            label: '项目关注重点',
            icon: 'mdi-home-outline ',
            path:'/Conversation/ProjectFocus',
            pid:101030,
          },
          {
            id:'1010307',
            label: '项目危机排名',
            icon: 'mdi-home-outline ',
            path:'/Conversation/ProjectCrisis',
            pid:101030,
          },
          {
            id:'1010308',
            label: '群活跃分析',
            icon: 'mdi-home-outline ',
            path:'/Conversation/GroupActive',
            pid:101030,
          },
          {
            id:'1010309',
            label: '群关注重点',
            icon: 'mdi-home-outline ',
            path:'/Conversation/GroupFocus',
            pid:101030,
          },
          {
            id:'1010310',
            label: '群危机排名',
            icon: 'mdi-home-outline ',
            path:'/Conversation/GroupCrisis',
            pid:101030,
          },
          {
            id:'1010311',
            label: '群成员分析',
            icon: 'mdi-home-outline ',
            path:'/Conversation/MemberAnalyze',
            pid:101030,
          },
      ],
    }
  },
  //界面没出来前加载
  created() {
    this.$myhttp.get('admin/lavel2?pid=101020',{
      'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
        if(backdata.data != 1){
          this.item = backdata.data;
        }else{
          this.item = this.items_list1;
        }
        // console.log(backdata.data)
      });
  },
}
</script>
<style scoped>
.daoh2{
    display: flex;
    height: 100%;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 130px;
  height: 100%;
}
a{
    text-decoration: none;
 }
.ti{
  height: 100%;
  width: 100%;
  background-color: white;
}

.router-link-active {

}

</style>



// WEBPACK FOOTER //
// src/components/Admin/App/Conversation/Index.vue